import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { CondicionesPagoController } from './condiciones-pago.controller';
import { CondicionesPagoService } from './condiciones-pago.service';

@Module({
  imports: [PrismaModule],
  controllers: [CondicionesPagoController],
  providers: [CondicionesPagoService],
  exports: [CondicionesPagoService],
})
export class CondicionesPagoModule {}
